<script setup lang="ts">
interface Props {
  label: string
}

defineProps<Props>()
</script>

<template>
  <div class="date-divider d-flex align-center justify-center my-4">
    <div class="date-chip px-3 py-1 text-caption">
      {{ label }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.date-chip {
  background: rgba(var(--v-theme-on-surface), 0.08);
  border-radius: 9999px;
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
  font-weight: 600;
}
</style>
